import { get, round } from 'lodash'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { ReactCountryFlag } from 'react-country-flag'

import { COUNTRIES, NO_DATA_MESSAGE } from '../../utils/constants'
import { fundCompositeValueRenderer } from '../../utils/functions'
import AsOfDate from '../AsOfDate'
import ScrollingTable from '../Tables/ScrollingTable'

const COUNTRY_ROW_STYLE = {
  display: 'flex',
  alignItems: 'center',
  columnGap: '12px',
  borderTop: 'unset',
}

const COUNTRY_FLAG_STYLE = {
  width: '25px',
  height: '25px',
}

class CountryAllocation extends PureComponent {
  constructor(props) {
    super(props)

    const countryAllocation =
      get(props, 'data.countryAllocation') ||
      get(props, 'data.country_allocation') ||
      []
    const asOfDate = countryAllocation?.[0]?.calendar?.date || ''
    const fundName =
      get(props, 'data.name') || get(props, 'fundTitle') || 'Fund'

    const tableData = []
    const columns = [
      {
        Header: 'Country',
        id: 'country',
        accessor: (holding) => {
          if (holding.name) {
            const countryCode =
              COUNTRIES.find(
                ({ Name }) => Name.toLowerCase() === holding.name.toLowerCase()
              )?.Code ?? ''
            return (
              <div style={COUNTRY_ROW_STYLE}>
                <span>{holding.name}</span>
                {!!countryCode && (
                  <ReactCountryFlag
                    countryCode={countryCode}
                    svg
                    style={COUNTRY_FLAG_STYLE}
                  />
                )}
              </div>
            )
          }
          return ''
        },
      },
      {
        Header: `${fundName} %`,
        id: 'fund',
        accessor: 'fund',
        Cell: fundCompositeValueRenderer,
      },
    ]

    if (countryAllocation && countryAllocation.length > 0) {
      if (countryAllocation[0]?.benchmarkIndex) {
        columns.push({
          Header: `${countryAllocation[0].benchmarkIndex.name} %`,
          id: 'benchmark-0',
          accessor: 'benchmark-0',
          Cell: fundCompositeValueRenderer,
        })
      }

      countryAllocation.forEach((item) => {
        const dataItem = {
          name: item.name,
          fund: item.fundValue || item.value,
        }

        if (item.benchmarkValue) {
          dataItem['benchmark-0'] = item.benchmarkValue
        }
        tableData.push(dataItem)
      })

      const fundOther =
        countryAllocation.reduce(
          (total, allocation) =>
            total + round((allocation.fundValue || allocation.value) * 100, 1),
          0
        ) / 100

      const indexOtherArray = [
        countryAllocation.reduce((total, alloc) => {
          const toAdd = alloc.benchmarkValue
            ? round(alloc.benchmarkValue * 100, 1)
            : 0
          return total + toAdd
        }, 0) / 100,
      ]

      tableData.push({
        name: 'Other',
        fund: 1 - fundOther,
        ...indexOtherArray.reduce((result, indexOther, idx) => {
          return {
            ...result,
            [`benchmark-${idx}`]: 1 - indexOther,
          }
        }, {}),
      })
    }

    this.state = {
      columns,
      data: tableData,
      asOfDate,
    }

    this.scrollingTableOptions = {
      stripedTable: true,
      presentation: props.presentation,
    }
  }

  render() {
    const { presentation } = this.props
    const { columns, data, asOfDate } = this.state

    if (data.length === 0) {
      return <p>{NO_DATA_MESSAGE}</p>
    }

    return (
      <>
        <AsOfDate date={asOfDate} />
        <ScrollingTable
          data={data}
          columns={columns}
          options={this.scrollingTableOptions}
        />
      </>
    )
  }
}

CountryAllocation.propTypes = {
  data: PropTypes.shape({
    countryAllocation: PropTypes.array,
    name: PropTypes.string,
  }),
  presentation: PropTypes.object,
}

export default CountryAllocation
